export enum QuestionCloseResult {
    YES,
    NO,
}
